<template>
  <div id="app">
    <notifications position="top center"></notifications>
    <router-view/>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      meta: [
        {charset: 'utf-8'}
      ]
    }
  }
</script>